export const idDocumentTypeValues = [
  'UMID',
  'PRC',
  'SSS',
  'PHIL_ID',
  'DRIVING_LICENSE',
  'PASSPORT',
  'POSTAL_ID',
  'PHIL_SYS_ID',
  'DIGITAL_NATIONAL_PHIL_ID',
  'E_PHIL_ID',
] as const;

export type IdDocumentType = (typeof idDocumentTypeValues)[number];

export type Document = {
  type: IdDocumentType;
  idNumber: string;
};

export type PersonLocation = {
  country?: string | null;
  region?: string | null;
  province?: string | null;
  cityOrMunicipality?: string | null;
  barangay?: string | null;
  postalCode?: string | null;
  streetAndHouse?: string | null;
  unitAndFloor?: string | null;
};

export type PersonCurrentAddress = {
  location?: PersonLocation | null;
};

export type PersonDataResponse = {
  firstName?: string | null;
  middleName?: string | null;
  lastName?: string | null;
  email?: string | null;
  birthDate?: string | null;
  currentAddress?: PersonCurrentAddress | null;
  pointOfContact?: string | null;
};

export type PersonDataRequest = {
  firstName: string;
  middleName?: string | null;
  lastName: string;
  email: string;
  birthDate: string;
  pointOfContact?: string | null;
  currentAddress?: PersonCurrentAddress | null;
};
